import script from "./SpeV2Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2Filters.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2Filters.vue?vue&type=style&index=0&id=66b0875e&scoped=true&lang=css"
import "./SpeV2Filters.vue?vue&type=style&index=1&id=66b0875e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b0875e"]])

export default __exports__